import { useSnapshot } from "valtio";
import uiState from "../data";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import { windowSizeState } from "../utils/windowSize";
import { googleSheet } from "../utils/getSheet";
const EnterPage = ({ event }) => {
  const imgRef = useRef(null);
  const containerRef = useRef();
  const { visible, hoverItem } = useSnapshot(uiState[event]);
  const { mobileMode } = useSnapshot(windowSizeState);
  const [canClick, setCanClick] = useState(true);
  const [isDrag, setIsDrag] = useState(false);
  const [startX, setStartX] = useState();
  const [isDown, setIsDown] = useState(false);
  const [scrollLeft, setScrollLeft] = useState();
  const [horizontalScroll, setHorizontalScroll] = useState(0);
  const [previousScroll, setPreviousScroll] = useState(0);
  const data = googleSheet["homepage"].filter((el) => {
    return el.part === "second_page";
  })[0];

  // GA
  function gtag() {
    window.dataLayer.push(arguments);
  }

  const handleScroll = (event) => {
    const container = containerRef.current;
    const maxHorizontalScroll = container.scrollWidth - container.clientWidth;

    const newScroll = Math.min(
      maxHorizontalScroll,
      Math.max(0, previousScroll + event.deltaY * 0.8),
    );

    setHorizontalScroll(newScroll);
    setPreviousScroll(newScroll);
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = horizontalScroll;
    }
  }, [horizontalScroll]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = horizontalScroll;
    }
  }, [horizontalScroll]);

  const handleMouseDown = (e) => {
    setIsDown(true);

    setStartX(e.pageX - e.target.offsetLeft);
    if (containerRef.current) {
      setScrollLeft(containerRef.current.scrollLeft);
    }
  };

  const handleMouseLeave = (e) => {
    setIsDown(false);
  };

  const handleMouseUp = (e) => {
    setIsDown(false);
    setTimeout(() => {
      setIsDrag(false);
    }, 300);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;

    e.preventDefault();
    const x = e.pageX - e.target.offsetLeft;
    const walk = (x - startX) * 1; // scroll-fast

    if (Math.abs(walk) > 100) {
      setIsDrag(true);
    }

    if (containerRef.current) {
      containerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  useEffect(() => {
    if (isDrag) {
      setCanClick(false);
    } else {
      setCanClick(true);
    }
  }, [isDrag]);

  const goExplore = () => {
    if (canClick) {
      uiState.communityPage.visible = true;
      uiState[event].visible = false;
      gtag("event", `homepage:select explore jupiter's community`);
    }
  };

  const goFactorySpa = () => {
    if (canClick) {
      uiState.factorySpa.visible = true;
      uiState[event].visible = false;
      gtag("event", `homepage:select discover the factory`);
    }
  };

  const goEnvironmentSpa = () => {
    if (canClick) {
      uiState.environmentSpa.visible = true;
      uiState[event].visible = false;
      gtag("event", `homepage:select learn about sustainability`);
    }
  };

  const goOfficialWeb = () => {
    if (canClick) {
      window.open("https://jupitermusic.com", "_blank");
      gtag("event", `homepage:select discover more instriment`);
    }
  };
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="screen-setting overflow-hidden fixed top-0 "
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src="../startImages/bg/bg.jpg"
            alt="背景圖片"
            className="w-full h-full"
          />
          <img
            src="../startImages/line/line2.png"
            alt="背景線"
            className="absolute top-0 left-1/2 h-full -translate-x-1/2"
          />
          {mobileMode && (
            <>
              <div className="absolute top-0 left-1/2 -translate-x-1/2 flex flex-col justify-between ">
                <div className="flex flex-col items-center">
                  <div>
                    <img
                      src="../startImages/logo/color.png"
                      alt="logo 彩色部分"
                      className="w-[50px] portraitBigPh:w-[30px] landscapePhone:w-[30px]"
                    />
                  </div>
                  <div>
                    <img
                      src="../startImages/logo/big_logo.png"
                      alt="黑色 logo"
                      className="w-[100px] portraitBigPh:w-[75px] landscapePhone:w-[75px] "
                    />
                  </div>
                </div>
              </div>

              <motion.div className="absolute bottom-[30px] sm:bottom-1/2 shortPhone:bottom-[16px]  sm:translate-y-1/2 shortPhone:translate-y-0  left-1/2  -translate-x-1/2 flex flex-col  w-[95%] justify-between smMd:w-[85%]  smMd:bottom-[16px] authPCHeight:w-[50%] landscapePhone:bottom-[16px] ">
                <div className="mb-6 shortPhone:mb-[20%] ">
                  <p
                    className={`text-center Trajan  portraitPad:text-[20px] portraitPh:text-[14px]  landscapePhone:hidden  whitespace-pre-wrap
                    `}
                  >
                    {data.en_title1}
                  </p>
                </div>
                <div className="landscapePhone:flex">
                  <div className="flex w-full ">
                    <div className="w-1/2">
                      <img
                        src="../startImages/pic/Explore_Jupiters_Community_ph.png"
                        alt="手機版圖片1"
                        className="w-full"
                        onClick={goExplore}
                      />
                    </div>
                    <div className="w-1/2">
                      <img
                        src="../startImages/pic/Start_Factory_Tour_ph.png"
                        alt="手機版圖片2"
                        className="w-full"
                        onClick={goFactorySpa}
                      />
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="w-1/2">
                      <img
                        src="../startImages/pic/Learn_About_Sustainability_ph.png"
                        alt="手機版圖片3"
                        className="w-full"
                        onClick={goEnvironmentSpa}
                      />
                    </div>
                    <div className="w-1/2">
                      <img
                        src="../startImages/pic/Experience_Instrumental_Brilliance_ph.png"
                        alt="手機版圖片4"
                        className="w-full"
                        onClick={goOfficialWeb}
                      />
                    </div>
                  </div>
                </div>
              </motion.div>
            </>
          )}

          {!mobileMode && (
            <>
              {/* 左右邊的遮罩 */}
              <div className=" absolute w-[10vw] h-full top-0 -left-[40px] bg-white blur-md z-10"></div>
              <div className=" absolute w-[8vw] h-full top-0 -right-[40px] bg-white blur-xl z-10"></div>

              <div className="absolute top-0 left-1/2 -translate-x-1/2 h-full flex flex-col justify-between ">
                <div className="flex flex-col items-center">
                  <div>
                    <img
                      src="../startImages/logo/color.png"
                      alt="logo 彩色部分"
                      className="w-[50px] "
                    />
                  </div>
                  <div>
                    <img
                      src="../startImages/logo/big_logo.png"
                      alt="黑色 logo"
                      className="w-[100px] "
                    />
                  </div>
                </div>
                <div>
                  <p
                    className={`text-center Trajan text-[20px] portraitPad:text-[20px] smallLaptop:text-[15px] portraitPh:text-[14px] w-[90vw]  landscapePhone:text-[17px] `}
                  >
                    {data.en_title1}
                  </p>
                </div>
                <div className="flex h-[68%] pointer-events-none"></div>
              </div>

              <div
                className="absolute bottom-[50px] overflow-x-scroll w-[100vw] left-0 flex Trajan text-[17px] smallLaptop:text-[12px] smallLaptop:bottom-[35px] landscapePad:bottom-[16px] landscapePad:text-[15px] hideScroll"
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                onWheel={handleScroll}
                ref={containerRef}
              >
                <div className="min-w-[580px] relative laptop:min-w-[500px] smallLaptop:min-w-[350px] landscapePad:min-w-[440px] ml-[7vw] ">
                  <div
                    className={`h-full w-full absolute top-0 left-0  z-10 ${
                      isDown ? "cursor-grab" : "cursor-pointer"
                    }`}
                    onMouseEnter={() => (uiState.enterPage.hoverItem = "item1")}
                    onMouseLeave={() => (uiState.enterPage.hoverItem = "")}
                    onClick={goExplore}
                  ></div>
                  <div
                    className={`h-[88%] laptop:h-[87%] landscapePad:h-[88%] w-[96%] landscapePad:w-[96.5%]  absolute top-[2.5%] left-[2.2%] laptop:left-[2%] landscapePad:left-[2%] rounded-[25px] border-[3px] border-mainOrange-100 ${
                      hoverItem === "item1" ? "border-[3px]" : "border-none"
                    } ${
                      hoverItem === "item1"
                        ? " border-mainOrange-100"
                        : "border-none"
                    }`}
                  ></div>
                  <img
                    ref={imgRef}
                    src="../startImages/pic/Explore_Jupiters_Community.png"
                    alt="圖片1"
                    className={`w-full  rounded-[50px]  `}
                  />

                  <p
                    className={` underline-offset-8 decoration-mainOrange-100 decoration-[3px] ml-[4%] mt-0 landscapePad:mt-2 smallLaptop:mt-2   ${
                      hoverItem === "item1" ? " underline" : " no-underline"
                    } `}
                    onClick={goExplore}
                  >
                    {data.en_subtitle1}
                  </p>
                </div>
                <div className="min-w-[580px] relative laptop:min-w-[500px] smallLaptop:min-w-[350px] landscapePad:min-w-[440px] ">
                  <div
                    className={`h-full w-full absolute top-0 left-0 z-10  ${
                      isDown ? "cursor-grab" : "cursor-pointer"
                    }`}
                    onMouseEnter={() => (uiState.enterPage.hoverItem = "item2")}
                    onMouseLeave={() => (uiState.enterPage.hoverItem = "")}
                    onClick={goFactorySpa}
                  ></div>
                  <div
                    className={`h-[88%] laptop:h-[86.5%] landscapePad:h-[87.5%] w-[96%] landscapePad:w-[96.5%] absolute bottom-[2.5%] left-[2.2%] laptop:left-[2%] landscapePad:left-[2%] rounded-[25px] border-[3px] ${
                      hoverItem === "item2" ? "border-[3px]" : "border-none"
                    } ${
                      hoverItem === "item2"
                        ? " border-mainOrange-100"
                        : "border-none"
                    }`}
                  ></div>
                  <p
                    className={`underline-offset-8 decoration-mainOrange-100 decoration-[3px] ml-[4%] mb-4  smallLaptop:mb-2  landscapePad:mb-2 ${
                      hoverItem === "item2" ? " underline" : " no-underline"
                    } `}
                    onClick={goFactorySpa}
                  >
                    {data.en_subtitle2}
                  </p>

                  <img
                    src="../startImages/pic/Start_Factory_Tour.png"
                    alt="圖片2"
                    className={`w-full rounded-[50px] `}
                  />
                </div>
                <div className="min-w-[580px] relative laptop:min-w-[500px] smallLaptop:min-w-[350px] landscapePad:min-w-[440px] ">
                  <div
                    className={`h-full w-full absolute top-0 left-0 z-10 ${
                      isDown ? "cursor-grab" : "cursor-pointer"
                    }`}
                    onMouseEnter={() => (uiState.enterPage.hoverItem = "item3")}
                    onMouseLeave={() => (uiState.enterPage.hoverItem = "")}
                    onClick={goEnvironmentSpa}
                  ></div>
                  <div
                    className={`h-[88%] laptop:h-[87%] landscapePad:h-[88.5%] w-[96%] landscapePad:w-[96.3%] absolute top-[2.5%] laptop:top-[2.2%] landscapePad:top-[2.2%] left-[2.2%] rounded-[25px] border-[3px] ${
                      hoverItem === "item3" ? "border-[3px]" : "border-none"
                    } ${
                      hoverItem === "item3"
                        ? " border-mainOrange-100"
                        : "border-none"
                    }`}
                  ></div>
                  <img
                    src="../startImages/pic/Learn_About_Sustainability.png"
                    alt="圖片3"
                    className={`w-full rounded-[50px]`}
                  />
                  <p
                    className={` underline-offset-8 decoration-mainOrange-100 decoration-[3px] ml-[4%] mt-0 smallLaptop:mt-2  landscapePad:mt-2 ${
                      hoverItem === "item3" ? " underline" : " no-underline"
                    } `}
                    onClick={goEnvironmentSpa}
                  >
                    {data.en_subtitle3}
                  </p>
                </div>
                <div className="min-w-[580px] relative laptop:min-w-[500px] smallLaptop:min-w-[350px] landscapePad:min-w-[440px] mr-[10%]  ">
                  <div
                    className={`h-full w-full absolute top-0 left-0 z-10 ${
                      isDown ? "cursor-grab" : "cursor-pointer"
                    }`}
                    onMouseEnter={() => (uiState.enterPage.hoverItem = "item4")}
                    onMouseLeave={() => (uiState.enterPage.hoverItem = "")}
                    onClick={goOfficialWeb}
                  ></div>
                  <div
                    className={`h-[88%] laptop:h-[86.5%] landscapePad:h-[88%] w-[96%] absolute bottom-[2.5%] left-[2.2%] rounded-[25px] border-[3px] ${
                      hoverItem === "item4" ? "border-[3px]" : "border-none"
                    } ${
                      hoverItem === "item4"
                        ? " border-mainOrange-100"
                        : "border-none"
                    }`}
                  ></div>
                  <p
                    className={`underline-offset-8 decoration-mainOrange-100 decoration-[3px] ml-[4%] mb-4 smallLaptop:mb-2   landscapePad:mb-2 ${
                      hoverItem === "item4" ? " underline" : " no-underline"
                    } `}
                  >
                    {data.en_subtitle4}
                  </p>
                  <img
                    src="../startImages/pic/Experience_Instrumental_Brilliance.png"
                    alt="圖片4"
                    className={`w-full rounded-[50px] `}
                  />
                </div>
              </div>
            </>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EnterPage;
